import React, { memo } from 'react'
import { FooterWrapper } from './css'

const Footer = memo(() => {
  return <FooterWrapper>2023 © React18 + antd5 template By Hooks Technology.</FooterWrapper>
})

export default Footer
